// extracted by mini-css-extract-plugin
module.exports = {"bgDot":"ErrorPage_bgDot__3QNDe","errorTitle":"ErrorPage_errorTitle__UYPy1","errorBody":"ErrorPage_errorBody__3ykwz","reloadBtnContainer":"ErrorPage_reloadBtnContainer__2EOZr"};